import { useCallback, useMemo } from 'react';

import { APP_ROUTES } from '../../constants';
import { APP_LINKS } from '../../constants/links.constant';
import { useAppConfig } from '../../context';
import { AppLink, AppRoute } from '../../enum';
import { RouteType } from '../../models';
import { LinkType } from '../../models/link.model';
import { TopMenuItem } from './top-menu-item.component';

export type TopMenuProps = { className?: string };

export const TopMenu = ({ className }: TopMenuProps) => {
  const cfg = useAppConfig();

  const items = useMemo(
    () => [
      APP_ROUTES[AppRoute.DocumentsHome],
      APP_ROUTES[AppRoute.UserManagement],
      APP_LINKS[AppLink.NetworkInventoryGateway],
      APP_LINKS[AppLink.NetworkInfrastructureMap],
      APP_ROUTES[AppRoute.Dashboards],
    ],
    []
  );

  const isLinkType = useCallback(
    (val: RouteType | LinkType): val is LinkType => 'link' in val,
    []
  );

  return (
    <nav className={className}>
      <ul className="flex space-x-4">
        {items.map((item) => (
          <TopMenuItem
            key={item.name}
            path={isLinkType(item) ? item.link(cfg) : item.path}
            name={item.name}
            requiredRoles={item.requiredRoles}
            isLink={isLinkType(item)}
          />
        ))}
      </ul>
    </nav>
  );
};
